module.exports = __webpack_public_path__ + "img/thumbnail_PrairieDog_m_normal.a92fa912.png";